var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationCharts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 606,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.9%",
    y: "-12.1%",
    width: "155.8%",
    height: "148.5%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12.5,
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 50,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.293478072 0 0 0 0 0.359720343 0 0 0 0 0.604534647 0 0 0 0.247159091 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-27.9%",
    y: "-25.7%",
    width: "155.8%",
    height: "202.7%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12.5,
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 50,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.293478072 0 0 0 0 0.359720343 0 0 0 0 0.604534647 0 0 0 0.247159091 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-27.9%",
    y: "-7.8%",
    width: "155.8%",
    height: "131.1%",
    filterUnits: "objectBoundingBox",
    id: "i"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12.5,
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 50,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.293478072 0 0 0 0 0.359720343 0 0 0 0 0.604534647 0 0 0 0.247159091 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 224,
    height: 309,
    rx: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f",
    x: 0,
    y: 0,
    width: 224,
    height: 146,
    rx: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "j",
    x: 0,
    y: 0,
    width: 224,
    height: 483,
    rx: 13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024AFF",
    stopOpacity: 0.148,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B77CF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 59,
    cy: 59,
    r: 59
  }), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 46)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    mask: "url(#e)",
    d: "M-36.826 240.688L56.5 209.026 112 127.17l56.5 18.01 75.17-116.672V269l-280.496-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5175FF",
    strokeWidth: 2,
    mask: "url(#e)",
    d: "M-36.826 240.688L56.5 209.026 112 127.17l56.5 18.01 75.17-116.672V269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5175FF",
    opacity: 0.152,
    mask: "url(#e)",
    d: "M112 0h1v250h-1zM56 0h1v250h-1zM169 0h1v250h-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5175FF",
    mask: "url(#e)",
    cx: 112,
    cy: 127,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#5175FF",
    opacity: 0.25,
    mask: "url(#e)",
    cx: 112,
    cy: 127,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5175FF",
    mask: "url(#e)",
    cx: 56,
    cy: 209,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5175FF",
    mask: "url(#e)",
    cx: 169,
    cy: 145,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5175FF",
    mask: "url(#e)",
    cx: 224,
    cy: 60,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5175FF",
    mask: "url(#e)",
    cy: 228,
    r: 6
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("text", {
    opacity: 0.5,
    fontFamily: "KumbhSans-Bold, Kumbh Sans",
    fontSize: 11,
    fontWeight: "bold",
    transform: "translate(-12 260)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 116.15,
    y: 32,
    fill: "#747B95"
  }, "Jan")), /*#__PURE__*/React.createElement("text", {
    opacity: 0.5,
    fontFamily: "KumbhSans-Bold, Kumbh Sans",
    fontSize: 11,
    fontWeight: "bold",
    transform: "translate(-12 260)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 57.779,
    y: 32,
    fill: "#747B95"
  }, "Dec")), /*#__PURE__*/React.createElement("text", {
    opacity: 0.5,
    fontFamily: "KumbhSans-Bold, Kumbh Sans",
    fontSize: 11,
    fontWeight: "bold",
    transform: "translate(-12 260)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.534,
    y: 32,
    fill: "#747B95"
  }, "Nov")), /*#__PURE__*/React.createElement("text", {
    opacity: 0.5,
    fontFamily: "KumbhSans-Bold, Kumbh Sans",
    fontSize: 11,
    fontWeight: "bold",
    transform: "translate(-12 260)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 170.308,
    y: 32,
    fill: "#747B95"
  }, "Feb")), /*#__PURE__*/React.createElement("text", {
    opacity: 0.5,
    fontFamily: "KumbhSans-Bold, Kumbh Sans",
    fontSize: 11,
    fontWeight: "bold",
    transform: "translate(-12 260)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 225.725,
    y: 32,
    fill: "#747B95"
  }, "Mar")), /*#__PURE__*/React.createElement("path", {
    fill: "#747B95",
    opacity: 0.25,
    d: "M0 268h224v1H0zM112 260h1v8h-1zM56 260h1v8h-1zM168 260h1v8h-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#g)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#333950",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.64 95v-2.448l-6.768-.936 3.96-13.68h16.56l4.392 13.896-6.408.72V95h24.552v-2.448l-5.76-.648L93.888 41H86.4L70.128 91.688l-5.976.864V95H80.64zM93.6 75.416H78.552l7.2-24.624L93.6 75.416zm58.176 20.808c4.608 0 7.344-1.656 9.144-5.616l-1.224-1.008c-1.368 2.16-2.16 2.736-3.24 2.736-1.368 0-2.232-.936-2.232-3.672V69.296c0-10.44-4.104-14.832-14.328-14.832-11.16 0-17.424 4.32-18 11.088.576 2.376 2.376 3.672 4.968 3.672 2.736 0 5.184-1.944 5.4-6.84l.504-5.112a14.805 14.805 0 013.024-.288c5.472 0 7.2 2.232 7.2 9.72v4.392c-2.52.648-5.04 1.296-7.056 1.872-11.592 3.384-15.336 6.912-15.336 13.464 0 6.048 4.32 9.792 10.512 9.792 5.76 0 8.496-2.232 12.168-6.264 1.08 3.888 3.744 6.264 8.496 6.264zm-15.048-4.896c-3.384 0-5.4-2.016-5.4-6.336 0-5.256 2.664-8.64 7.704-10.728.864-.36 2.304-.792 3.96-1.224v14.976c-2.664 2.376-4.32 3.312-6.264 3.312zM63 100v4h95.132v-4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M-67 71v4h95.132v-4zM193 71v4h95.132v-4z",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5175FF",
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    opacity: 0.15,
    d: "M276 182h224v1H276z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(329 32)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    opacity: 0.146,
    cx: 59,
    cy: 59,
    r: 55.5
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#5CFCD3",
    mask: "url(#k)",
    strokeWidth: 20,
    strokeDasharray: 302,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "KumbhSans-Bold, Kumbh Sans",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#5CFCD3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 70
  }, "87%"))), /*#__PURE__*/React.createElement("text", {
    fontFamily: "KumbhSans-Bold, Kumbh Sans",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#FFF",
    transform: "translate(276)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 76,
    y: 236
  }, "98k")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 282)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7DA7FF",
    x: 29,
    width: 131,
    height: 14,
    rx: 7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 316)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7DA7FF",
    x: 29,
    width: 83,
    height: 14,
    rx: 7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 350)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7DA7FF",
    x: 29,
    width: 131,
    height: 14,
    rx: 7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 384)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7DA7FF",
    x: 29,
    width: 79,
    height: 14,
    rx: 7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 418)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 14,
    height: 14,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7DA7FF",
    x: 29,
    width: 131,
    height: 14,
    rx: 7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCharts);
export default __webpack_public_path__ + "static/media/illustration-charts.d82774d50fca5e35f8f0cfb36f4fb5a5.svg";
export { ForwardRef as ReactComponent };